import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Settings, Search, Share2 } from 'lucide-react';
import { useThemeStore } from '../../app/themeStore.js';
import { useGpsStatus } from './useFix.js';
import { WindChip } from '../conditions/WindChip.js';
import { SearchSheet } from '../search/SearchSheet.js';
import { ShareSheet } from '../share/ShareSheet.js';
import { msg } from '../../lib/messages.js';
import './topbar.css';

export function TopBar(): JSX.Element {
  const status = useGpsStatus();
  const theme = useThemeStore((s) => s.theme);
  const toggle = useThemeStore((s) => s.toggle);
  const [searchOpen, setSearchOpen] = useState(false);
  const [shareOpen, setShareOpen] = useState(false);

  const warn = status === 'stale' || status === 'lost' || status === 'denied';
  const gpsLabel = msg.gps[status] ?? msg.gps.idle;

  return (
    <div className="topbar">
      <div className="topbar__brand numeral">{msg.app.name}</div>
      <div className="topbar__right">
        <WindChip />
        <span className={`gps-chip${warn ? ' gps-chip--warn' : ''}`}>
          <span className="gps-chip__dot" />
          {gpsLabel}
        </span>
        <button
          type="button"
          className="topbar__search"
          onClick={() => setSearchOpen(true)}
          aria-label={msg.search.title}
        >
          <Search size={18} aria-hidden="true" />
        </button>
        <button
          type="button"
          className="topbar__search"
          onClick={() => setShareOpen(true)}
          aria-label={msg.share.title}
        >
          <Share2 size={18} aria-hidden="true" />
        </button>
        <button
          type="button"
          className="theme-toggle"
          onClick={toggle}
          aria-label={msg.theme.toggle}
        >
          {theme === 'day' ? msg.theme.night : msg.theme.day}
        </button>
        <Link to="/innstillinger" className="topbar__gear" aria-label={msg.settings.title}>
          <Settings size={20} aria-hidden="true" />
        </Link>
      </div>
      {searchOpen && <SearchSheet onClose={() => setSearchOpen(false)} />}
      {shareOpen && <ShareSheet onClose={() => setShareOpen(false)} />}
    </div>
  );
}
